import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2'; // Import SweetAlert2

function ProfileNavbar() {
  const location = useLocation(); // Get the current location

  // Helper function to check if the current path matches the link
  const isActive = (path) => location.pathname === path;

  // Handle logout with SweetAlert2 confirmation
  const handleLogout = () => {
    // Show confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: "You will be logged out from your account!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log out!',
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear visitor details from localStorage
        localStorage.removeItem('visitor_name');
        localStorage.removeItem('visitor_id');
        localStorage.removeItem('visitor_email');
        
        // Redirect to the homepage
        window.location.href = '/'; // Redirect to the home page
      }
    });
  };

  return (
    <>
      <div className="bg-white mt-3 p-2 py-3 mb-3 text-start">
        <div>
          <Link to="/my-events">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/my-events') ? 'prfactive' : ''}`}>My Events</div>
          </Link>
          <Link to="/my-event-calander">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/my-event-calander') ? 'prfactive' : ''}`}>Event Calendar</div>
          </Link>
          <Link to="/message">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/message') ? 'prfactive' : ''}`}>Message</div>
          </Link>
          <Link to="/my-connection">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/my-connection') ? 'prfactive' : ''}`}>Connection</div>
          </Link>
          <Link to="/follow">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/follow') ? 'prfactive' : ''}`}>Followed Events</div>
          </Link>

          <Link to="/profile">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/profile') ? 'prfactive' : ''}`}>My Profile</div>
          </Link> 
          {/* <Link to="/change-password">
            <div className={`linkprof py-2 mb-2 px-2 ${isActive('/change-password') ? 'prfactive' : ''}`}>Change Password</div>
          </Link>  */}
          {/* Logout link modified to use the handleLogout function */}
          {/* <div
            className={`linkprof py-2 mb-2 px-2 ${isActive('/logout') ? 'prfactive' : ''}`}
            onClick={handleLogout}
            style={{ cursor: 'pointer' }} // Make sure the div looks clickable
          >
            Logout
          </div> */}
        </div>
      </div>
    </>
  );
}

export default ProfileNavbar;
